// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckoutRegisterPage_wrapper__fyNHx","left":"CheckoutRegisterPage_left__wM0El","right":"CheckoutRegisterPage_right__1NwFH"};